import { APP_INITIALIZER, Provider } from '@angular/core';

/**
 * Magic Link Configuration Initializer
 *
 * This is now a no-op placeholder since we use ABP's normal login flow.
 * Kept for backwards compatibility with app.module.ts
 */
export function magicLinkConfigInitializer() {
  return () => {
    return Promise.resolve();
  };
}

/**
 * Provider to register the magic link initializer
 */
export const MAGIC_LINK_INITIALIZER_PROVIDER: Provider = {
  provide: APP_INITIALIZER,
  useFactory: magicLinkConfigInitializer,
  deps: [],
  multi: true
};
